var map = {
	"./active-btn.webp": 2519,
	"./angbao-bonus-cny.webp": 2520,
	"./angbao-bonus-dewali.webp": 2521,
	"./angbao-bonus-mooncake.webp": 2522,
	"./angbao-bonus-raya.webp": 2523,
	"./angbao-bonus-thaipusam.webp": 2524,
	"./angbao-bonus.webp": 2525,
	"./anni-lucky-draw.webp": 2526,
	"./cny-angbao-bonus.webp": 2527,
	"./cny-lucky-draw.webp": 2528,
	"./cny-promo.webp": 2529,
	"./dewali-promo.webp": 2530,
	"./dongzhi-angbao-bonus.webp": 2531,
	"./fifa-prediction.webp": 2532,
	"./fifa-qna.webp": 2533,
	"./uefa-predic.webp": 2534,
	"./welcome-cny-bonus.webp": 2535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2518;